import { redirect, RouteObject } from 'react-router-dom';

import i18n from 'app/i18n';
import { users } from 'app/services';
import { ModuleLayout } from 'app/layouts';

import Form from './form';
import List from './list';

export const routes: RouteObject[] = [
  { path: 'users', element: <ModuleLayout />,
    handle: { title: i18n.t('users.title') },
    children: [
      { path: '', index: true, element: <List />,
        handle: { permission: 'users:read', exclude: true },
      },
      { path: 'new', element: <Form />,
        handle: { title: i18n.t('users.new'), permission: 'users:create' },
      },
      { path: ':id', element: <Form />,
        loader: ({ params: { id } }) => users.get(id!).then(({ data }) => data ?? redirect('..')),
        handle: { title: (user: any) => (user && i18n.t('users.edit', user)), permission: 'users:update' },
      },
    ],
  },
];
